import { createAction, props } from '@ngrx/store';
import { ITypeExpenses } from 'src/app/shared/interfaces/expenses/itypeExpenses';

enum TypeExpensesActionType {
  LOAD_TYPE_EXPENSES = '[typeExpenses] load typeExpenses from api',
  LOAD_TYPE_EXPENSES_SUCCESS = '[typeExpenses] load typeExpenses from api return success',
  LOAD_TYPE_EXPENSES_ERROR = '[typeExpenses] load typeExpenses from api return error',
}
export const loadTypeExpenses = createAction(
  TypeExpensesActionType.LOAD_TYPE_EXPENSES
);
export const loadTypeExpensesSuccess = createAction(
  TypeExpensesActionType.LOAD_TYPE_EXPENSES_SUCCESS,
  props<{ lista: ITypeExpenses[] }>()
);
